import type { Prototype } from "../prototype-types";

export const beccaSabnaniPrototypes: Prototype[] = [
  {
    id: "external-retail-prices-pdp",
    name: "Surface external retail prices on PDP",
    path: "/bs/external-retail-prices-pdp",
    description:
      "Display scraped retail prices from external sources (brand websites, 3p sites) on the PDP so retailers can make more informed purchase decisions.",
    owner: "Becca",
    createdAt: "2026-03-04",
    lastUpdated: "2026-03-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/deaa7d39b7f9b65bab1575f9929df7e1f0cec49569d17255e0c0eff2b8254502.png",
    figmaLink:
      "https://www.figma.com/design/MiVqUOAycQuXdFapLk5hHG/PDP?node-id=1-10",
    creationTool: "cursor",
  },
];
